import styled, {css} from "styled-components";
import {AnimatedList} from "react-animated-list";
import Card from "../Card";
import {Cancel, Completed, InProgress, Pending} from "./Icons";
import {COLORS, MEDIA, OrderState, orderStatus} from "utils/constants";
import {Link} from "react-router-dom";

import {CircularImageProps, RadioSelectorProps} from "../../@types/Types";
import {Column, Row} from "../../layouts";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import React from "react";
import {isBrowser, isMobileOnly, isTablet} from "react-device-detect";



export const DeliveryItem = styled(Row)`
  gap: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex: 1;

  .productName{
    font-weight: 600;
    margin: 0.3rem 0;
    font-size: 14px;
  }
  .expires_on {
    font-size: 12px;
    color: ${COLORS.colorGray500};
    text-transform: capitalize;
  }
`

export const CardYellowTopWrapper = styled(Card)`
  padding: 0;
  min-width: min(100%, 450px);
  height: fit-content;
  min-height: fit-content;
  border-top: 6px solid #F9E600;
  display: flex;
  flex-direction: column;
  ${MEDIA.isMobile}{
    min-height: fit-content;
  }
`

export const CardYellowBottomWrapper = styled(Card)`
  padding: 0;
  width: min(100%, 450px);
  height:fit-content;
  border-bottom: 6px solid #F9E600!important;
  display: flex;
  flex-direction: column;
`


export const FileUploader = styled.input`
  height: 40px;
  width: 100%;
  border: 1px solid ${COLORS.colorBorder};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 12px;
  overflow: hidden;
  color: ${COLORS.colorWhite};
  &::file-selector-button{
    height: 100%;
    background: ${COLORS.colorBorder};
    border: none;
    color: ${COLORS.colorGray900};
    font-size: 12px;
    cursor: pointer;
    border-radius: 0;
  }
  &::placeholder{
    font-size: 12px;
  }
`



export const CustomLink = styled(Link)`
  font-weight: 600;
  position: relative;
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;
  z-index: 0;
  font-size: inherit;
  color: ${COLORS.colorBlack};
   &:after{
    position: absolute;
    content: "";
    left: 0;
    top: 100%;
    width: 100%;
    height: 1px;
    background-color: ${COLORS.colorBlack};
  }
  &:before{
    content: "";
    position: absolute;
    height: 100%;
    bottom: 0;
    width: 100%;
    background-color: ${COLORS.primaryYellow};
    z-index: -1;
  }
`

export const LinkButton = styled.button`
  font-weight: 600;
  position: relative;
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;
  z-index: 0;
  font-size: inherit;
  border: none;
  color: ${COLORS.colorBlack};
   &:after{
    position: absolute;
    content: "";
    left: 0;
    top: 100%;
    width: 100%;
    height: 1px;
    background-color: ${COLORS.colorBlack};
  }
  &:before{
    content: "";
    position: absolute;
    height: 100%;
    bottom: 0;
    width: 100%;
    background-color: ${COLORS.primaryYellow};
    z-index: -1;
  }
`




export const CircularImage = styled(LazyLoadImage)<CircularImageProps>`
  height: ${props => `${props.size}px` || '40px'};
  width: ${props => `${props.size}px` || '40px'};
  min-height: ${props => `${props.size}px` || '40px'};
  min-width: ${props => `${props.size}px` || '40px'};
  object-fit: cover;
  object-position: center;
  border-radius: 100%;
`

export const ProductImage = styled(LazyLoadImage)<CircularImageProps>`
  height: ${props => `${props.size}px` || '40px'};
  width: ${props => `${props.size + 4}px` || '45px'};
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  background-color: whitesmoke;
  align-items: center;
`


export const CircularPlaceholder = styled.div<CircularImageProps>`
  height: ${(props:CircularImageProps) => `${props.size}px` || '40px'};
  width: ${(props:CircularImageProps) => `${props.size}px` || '40px'};
  min-height: ${(props:CircularImageProps) => `${props.size}px` || '40px'};
  min-width: ${(props:CircularImageProps) => `${props.size}px` || '40px'};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin: 0;
`


const OrderStatusContainer = styled.span`
    display: flex;
    align-items: center;
    height: fit-content;
    width: fit-content;
    border: 1px solid ${COLORS.colorBorder};
    padding: 2px 4px;
    span {
        font-size: 10px;
        font-weight: 400;
        text-transform: uppercase;
        color: ${COLORS.colorGray900};
    }

    ${MEDIA.isMobile} {
        svg {
            height: 10px;
        }
    }
`;

export const OrderStateIcons: any = {
  [OrderState.others]: <Pending size={16}/>,
  [OrderState.completed]: <Completed color={"teal"} size={16}/>,
  [OrderState.rejected]: <Completed color={"red"} size={16}/>,
  [OrderState.canceled]: <Cancel size={16}/>,

}


export const ORDER_STATE:any = {
  [orderStatus.completed]: <OrderStatusContainer><Completed color={"teal"} size={14}/> <span
    style={{marginLeft: '2px'}}>Completed</span></OrderStatusContainer>,
  [orderStatus.pending]: <OrderStatusContainer><Pending size={14}/>
    <span style={{marginLeft: '2px'}}>Pending</span></OrderStatusContainer>,
  [orderStatus.accepted]: <OrderStatusContainer><Pending size={14}/>
    <span style={{marginLeft: '2px'}}>Accepted</span></OrderStatusContainer>,
  [orderStatus.onItsWay]: <OrderStatusContainer><InProgress size={14}/> <span
    style={{marginLeft: '2px'}}>On It's Way</span></OrderStatusContainer>,
  [orderStatus.delayed]: <OrderStatusContainer><Pending size={16}/>
    <span style={{marginLeft: '2px'}}>Delayed</span></OrderStatusContainer>,
  [orderStatus.inProgress]: <OrderStatusContainer><InProgress size={14}/> <span
    style={{marginLeft: '2px'}}>In Progress</span></OrderStatusContainer>,
  [orderStatus.canceled]: <OrderStatusContainer><Cancel size={14}/> <span
    style={{marginLeft: '2px'}}>Canceled</span></OrderStatusContainer>,
  [orderStatus.rejected]: <OrderStatusContainer><Cancel size={14}/>
    <span style={{marginLeft: '2px'}}>Rejected</span>
  </OrderStatusContainer>
}

export const ClearMarkWrapper = styled.button`
  height: fit-content;
  width: fit-content;
  background: none;
  border: none;
  outline: none;
  box-sizing: border-box;
  display: grid;
  place-content: center;
  svg{
    color:${(props:any)=> props.color || 'red'};
    height: 18px;
  }
`

export const Clear = (props: any) => <ClearMarkWrapper {...props}>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
</ClearMarkWrapper>







export const RadioSelector = styled.div<RadioSelectorProps>`
  height: 17px;
  width: 17px;
  max-width: 17px;
  background-color: ${({selected}:any)=> selected ? COLORS.primaryBlack: 'transparent'};
  border: ${({selected}:any)=> selected ? `6px solid ${COLORS.primaryYellow}`: `1px solid ${COLORS.colorBorder}`};
  border-radius: 100%;
  color: ${COLORS.colorWhite};
`

export const RadioButton = ({selected, label, onClick}:{
  selected: boolean,
  label?: string,
  onClick: ()=> void
}) => {
  return <label style={{
    display: 'flex',
    width: 'fit-content',
    columnGap: '6px',
    alignItems: 'center',
  }} onClick={()=> onClick?.()}>
    <RadioSelector selected={selected}/>
    {
      label && (<p style={{color:COLORS.colorWhite, fontWeight:'bold'}}>{label}</p>)
    }
  </label>
}


export const ImageSelector = styled.div`
  background: ${COLORS.primaryGray};
  height: 279px;
  width: 279px;
  border-radius: 100%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    height: 50px;
    width: 50px;
    border-radius: 30px;
    display: grid;
    place-content: center;
    background-color: ${COLORS.primaryYellow};
  }
`


export const CircularButton = styled.button`
  min-height: 30px;
  min-width: 30px;
  height: 50px;
  width: 50px;
  border-radius: 100px;
  overflow: hidden;
  border: none;
  background: ${COLORS.colorBg};
  display: flex;
  align-items: center;
  justify-content: center;
`



export const CartButton = styled.div`
  position: relative;
  cursor: pointer;
  span{
    position: absolute;
    top: -4px;
    right: -4px;
    height: 20px;
    width: 20px;
    background-color: black;
    color: #F9E600;
    display: grid;
    place-content: center;
    font-weight: 600;font-size: 12px;
    border-radius: 100%;
  }
`


export const FAB = styled.button<any>`
  height: 50px;
  width: 50px;
  border-radius: 100%;
  border: none;
  outline: none;
  display: grid;
  place-content: center;
  box-shadow: rgba(0, 0, 0, 0.07) 0 1px 2px, rgba(0, 0, 0, 0.07) 0 2px 4px, rgba(0, 0, 0, 0.07) 0 4px 8px, rgba(0, 0, 0, 0.07) 0 8px 16px, rgba(0, 0, 0, 0.07) 0 16px 32px, rgba(0, 0, 0, 0.07) 0 32px 64px;
 ${MEDIA.isMobile}{
   height: 44px;
   width: 44px;
 }
`

export const Badge = styled.div<{bg?:string, color?:string}>`
  height: fit-content;
  width: fit-content;
  text-transform: capitalize;
  font-size: clamp(0.5rem, 2.5vw, 0.7rem);
  padding: 4px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  background-color: ${(({bg}:any) => bg ?? COLORS.colorBg)};
  color: ${(({color}:any) => color ?? COLORS.colorBlack)};
  border-radius: 4px;
`




export const DataField = ({label, text, disabled}:{
  label?: string,
  text?: number |string | JSX.Element,
  disabled?: boolean
}) => (
  <Column disabled={disabled} style={{flex: 1, gap:'1px'}}>
    <Label style={{fontSize: '12px', color: COLORS.colorWhite, textAlign:'left'}}>{label}</Label>
    <span style={{minHeight:'20px',fontSize:'16px', fontWeight:'700', textAlign:'start', color: COLORS.colorWhite}}>{text ?? "N/A"}</span>
  </Column>
)

export const ListContainer = styled.div`
  display: grid;
  ${isMobileOnly && css`
    grid-template-columns: repeat(1, 1fr);
  `}
  ${isTablet && css`
    grid-template-columns: repeat(2, 1fr);
  `}
  ${isBrowser && css`
    grid-template-columns: repeat(3, 1fr);
  `}
  
`

export const List = styled(AnimatedList)<any>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1rem;
  & > div{
    width: 100%!important;
  }
`

export const RowList = styled(AnimatedList)<any>`
  display: flex;
  flex-direction: row!important;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1rem;
  & > div{
    width: 100%;
  }
`

export const BinContentTag = styled.div`
  height:20px;
  width:fit-content;
  padding: 0 8px;
  font-size:12px;
  background-color: #F9E600;
  border-radius:10px;
  font-weight:500;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  `;

export const InfoTag = styled.span`
  padding: 3px 6px;
  background-color: ${COLORS.primaryYellow};
  font-weight: 500;
  max-height: fit-content;
  min-width: fit-content;
  font-size: 13px;
`

export const Label = styled.label`
  font-size: 13px;
  width: fit-content;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  display: flex;
  align-items: start;
  justify-content: start;
  gap: 2px;
  color: ${COLORS.colorWhite};
  font-weight: 600;

  ${MEDIA.isMobile} {
    font-size: 12px;
  }
`

export const CardHeader = styled.div`
  padding: 1rem;
  background: linear-gradient(to right, #222222, #222222);
  width: 100%;
  min-height: 50px;
  max-height: fit-content;
  display: grid;
    h4, div h4{
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 14px
    }
`

export const GreenDot = styled.div`
  height: 8px;
    width: 8px;
    background: green;
    border-radius: 100%;
`

export const PulseTag = styled.span`
  font-size: 10px;
  padding:2px 4px;
  background-color: red;
  color: white;
  font-weight: 600;
  border-radius: 4px;
  animation: pulse 2s infinite;


  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
    }
  }
`

export const OrderFilter = styled.div<any>`
    height: 30px;
    padding: 0 12px 0 8px;
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    background-color: ${({selected}: any) => selected ? COLORS.colorWhite : COLORS.colorBg};
    border: 1px solid ${COLORS.colorBorder};
    border-radius: 15px;
    font-size: 14px;
    text-transform: lowercase;
`





